<!-- Edit Template -->

@if ({
  editPanelBulkEdit: slideAuthorFacade.editPanelBulkEdit$ | async
}; as editPanelData) {
  @if (editPanelData.editPanelBulkEdit) {
    <medsurf-slide-edit-bulk-edit class="flex flex-1 flex-column overflow-hidden"></medsurf-slide-edit-bulk-edit>
  } @else {
    @if ({
      editPanelOverlay: slideAuthorFacade.editPanelOverlay$ | async,
      editPanelDisplay: slideAuthorFacade.editPanelDisplay$ | async
    }; as editPanelOverlayData) {
      @switch (editPanelOverlayData.editPanelDisplay) {
        @case (FlatModels.SlideAuthorModels.EditPanelDisplay.enum.layer) {
          <medsurf-slide-edit-layer class="flex flex-1 flex-column overflow-hidden"></medsurf-slide-edit-layer>
        }
        @case (FlatModels.SlideAuthorModels.EditPanelDisplay.enum.question) {
          <medsurf-slide-edit-question class="flex flex-1 flex-column overflow-hidden"></medsurf-slide-edit-question>
        }
        @case (FlatModels.SlideAuthorModels.EditPanelDisplay.enum.group) {
          <medsurf-slide-edit-group class="flex flex-1 flex-column overflow-hidden"></medsurf-slide-edit-group>
        }
        @case (FlatModels.SlideAuthorModels.EditPanelDisplay.enum.poi) {
          <medsurf-slide-edit-poi class="flex flex-1 flex-column overflow-hidden"></medsurf-slide-edit-poi>
        }
        @case (FlatModels.SlideAuthorModels.EditPanelDisplay.enum.image) {
          <medsurf-slide-edit-media class="flex flex-1 flex-column overflow-hidden"></medsurf-slide-edit-media>
        }
        @case (FlatModels.SlideAuthorModels.EditPanelDisplay.enum.annotation) {
          @if (slideAuthorFacade.currentSelectedSlideAnnotation$ | async; as annotation) {
            @switch (annotation.type) {
              <!-- Marker -->
              @case (FlatModels.AnnotationEntityModels.AnnotationType.enum.Marker) {
                <medsurf-slide-edit-marker
                class="flex flex-1 flex-column overflow-hidden"></medsurf-slide-edit-marker>
              }
              <!-- Free Form -->
              @case (FlatModels.AnnotationEntityModels.AnnotationType.enum.FreeForm) {
                <medsurf-slide-edit-free-form
                class="flex flex-1 flex-column overflow-hidden"></medsurf-slide-edit-free-form>
              }
              <!-- Keymap -->
              @case (FlatModels.AnnotationEntityModels.AnnotationType.enum.Keymap) {
                <medsurf-slide-edit-keymap
                class="flex flex-1 flex-column overflow-hidden"></medsurf-slide-edit-keymap>
              }
            }
          }
        }
      }
      <!-- Fix to Show Metadata as Default -->
      @if (editPanelOverlayData.editPanelOverlay === false && editPanelOverlayData.editPanelDisplay === FlatModels.SlideAuthorModels.EditPanelDisplay.enum.list || editPanelOverlayData.editPanelDisplay === FlatModels.SlideAuthorModels.EditPanelDisplay.enum.metadata) {
        <medsurf-slide-edit-metadata class="flex flex-1 flex-column overflow-hidden"></medsurf-slide-edit-metadata>
      }
    }
  }
}
